import { defineComponent as _defineComponent } from 'vue'
import {
  ContentDisplay,
  ListDisplay,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';

import { CustomOperation } from '@/modules/trade/services/custom-operations';

interface Props {
  customOperationData: CustomOperation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StrikeOptions',
  props: {
    customOperationData: null
  },
  setup(__props: any) {



return { __sfc: true,ContentDisplay, ListDisplay, HeadingDisplay }
}

})